// Карточка одного незавершённого упражнения с прогрессом и кнопкой «Продолжить».

import { Badge, Card, Row, Col, ProgressBar, Button } from 'react-bootstrap';

function timeAgo(iso) {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  if (mins < 1) return 'только что';
  if (mins < 60) return `${mins} мин назад`;
  if (hours < 24) return `${hours} ${hours === 1 ? 'час' : hours < 5 ? 'часа' : 'часов'} назад`;
  if (days === 1) return 'Вчера';
  return `${days} дня назад`;
}

/**
 * Карточка одного незавершённого упражнения.
 *
 * @param {{
 *   item: {
 *     exercise_id: number,
 *     exercise_name: string,
 *     exercise_type_name: string | null,
 *     created_at: string,
 *     correct_count: number | null,
 *     total_questions: number | null,
 *     score_percent: number | null,
 *   },
 *   onContinue: (exerciseId: number) => void
 * }} props
 */
export default function IncompleteExerciseCard({ item, onContinue }) {
  const {
    exercise_id,
    variant_id,
    exercise_name,
    exercise_type_name,
    created_at,
    correct_count,
    total_questions,
    score_percent,
  } = item;

  const hasProgress = total_questions > 0;
  const progress = hasProgress
    ? Math.round(((correct_count ?? 0) / total_questions) * 100)
    : 0;

  const progressColor =
    progress >= 80 ? '#198754' : progress >= 50 ? '#ffc107' : '#0d6efd';

  const progressVariant =
    progress >= 80 ? 'success' : progress >= 50 ? 'warning' : 'primary';

  return (
    <Card
      className="border-0"
      style={{
        borderRadius: '0.875rem',
        boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
        background: '#fff',
      }}
    >
      <Card.Body className="p-4">
        <Row className="align-items-center g-3">

          {/* Левая часть: информация */}
          <Col>
            <h6
              className="fw-bold mb-1"
              style={{ color: '#1e2a4a', fontSize: '1rem' }}
            >
              {exercise_name}
            </h6>

            <div className="d-flex align-items-center gap-2 mb-3">
              {exercise_type_name && (
                <Badge
                  bg="secondary"
                  style={{ fontWeight: 500, fontSize: '0.75rem' }}
                >
                  {exercise_type_name}
                </Badge>
              )}
              <span style={{ color: '#6c757d', fontSize: '0.8rem' }}>
                ⏱ {timeAgo(created_at)}
              </span>
            </div>

            {hasProgress && (
              <>
                <div className="d-flex justify-content-between mb-1">
                  <span style={{ fontSize: '0.8rem', color: '#6c757d' }}>
                    Прогресс выполнения
                  </span>
                  <span
                    style={{
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      color: progressColor,
                    }}
                  >
                    {progress}%
                  </span>
                </div>

                <ProgressBar
                  now={progress}
                  variant={progressVariant}
                  style={{ height: '0.5rem', borderRadius: '1rem' }}
                />

                <div
                  className="mt-2"
                  style={{ fontSize: '0.8125rem', color: '#6c757d' }}
                >
                  ✓ {correct_count ?? 0} из {total_questions} вопросов
                  {score_percent != null && (
                    <span
                      className="ms-3"
                      style={{ color: progressColor, fontWeight: 600 }}
                    >
                      Текущий балл: {score_percent}%
                    </span>
                  )}
                </div>
              </>
            )}
          </Col>

          {/* Правая часть: кнопка */}
          <Col xs="auto">
            <Button
              variant="dark"
              size="sm"
              onClick={() => onContinue(exercise_id, variant_id)}
              style={{ borderRadius: '0.4rem', fontWeight: 600 }}
            >
              ▶ Продолжить
            </Button>
          </Col>

        </Row>
      </Card.Body>
    </Card>
  );
}
